import { useEffect, useRef } from 'react';

function drawArcSymbol(ctx, size, alpha) {
  ctx.strokeStyle = `rgba(0, 200, 255, ${alpha})`;
  ctx.lineWidth = 2;
  ctx.lineCap = 'round';
  ctx.beginPath();
  ctx.moveTo(-size, size * 0.55);
  ctx.quadraticCurveTo(0, -size, size, size * 0.55);
  ctx.stroke();
}

export default function ParticleBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let raf;
    let w, h;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    const count = mobile ? 26 : 68;

    const particles = [];
    const symbols = [];

    const resize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    for (let i = 0; i < count; i++) {
      particles.push({
        x: Math.random() * w,
        y: Math.random() * h,
        r: Math.random() * 1.8 + 0.6,
        vy: -(Math.random() * 0.22 + 0.06),
        vx: (Math.random() - 0.5) * 0.12,
        tw: Math.random() * Math.PI * 2,
        blue: Math.random() > 0.25
      });
    }
    const symCount = mobile ? 3 : 6;
    for (let i = 0; i < symCount; i++) {
      symbols.push({
        x: Math.random() * w,
        y: Math.random() * h,
        s: 7 + Math.random() * 10,
        vy: -(Math.random() * 0.14 + 0.04),
        a: Math.random() * Math.PI * 2,
        alpha: 0.05 + Math.random() * 0.08
      });
    }

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of particles) {
        p.tw += 0.02;
        if (!reduced) {
          p.x += p.vx;
          p.y += p.vy;
        }
        if (p.y < -10) { p.y = h + 10; p.x = Math.random() * w; }
        if (p.x < -10) p.x = w + 10;
        if (p.x > w + 10) p.x = -10;
        const alpha = 0.25 + Math.abs(Math.sin(p.tw)) * 0.45;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = p.blue
          ? `rgba(0, 200, 255, ${alpha})`
          : `rgba(255, 181, 46, ${alpha * 0.8})`;
        ctx.fill();
      }
      for (const s of symbols) {
        if (!reduced) {
          s.y += s.vy;
          s.a += 0.004;
        }
        if (s.y < -30) { s.y = h + 30; s.x = Math.random() * w; }
        ctx.save();
        ctx.translate(s.x, s.y);
        ctx.rotate(Math.sin(s.a) * 0.3);
        drawArcSymbol(ctx, s.s, s.alpha);
        ctx.restore();
      }
      raf = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      aria-hidden="true"
      data-testid="particle-background"
      className="pointer-events-none fixed inset-0 z-[4] mix-blend-screen"
    />
  );
}
